// SidebarBucketsModals.jsx

import React from 'react';

// Components
import AddDatabaseModal from 'components/adddatabasemodal/AddDatabaseModal';
import DashboardModal from 'main/sidebar/dashboards/DashboardModal';
import ChannelModal from 'main/sidebar/channels/ChannelModal';

/**
 * SidebarBucketsModals
 *
 * Renders the modal stack used by the sidebar buckets section.
 *
 * @param {object} modalState - Modal state values and setters for the sidebar buckets flow.
 *
 * @returns {ReactNode} The rendered modal stack.
 */
const SidebarBucketsModals = ({ modalState }) => {
    return (
        <>
            <DashboardModal
                isOpen={modalState.dashboardModalOpen}
                onClose={() => modalState.setDashboardModalOpen(false)}
            />

            <ChannelModal
                isOpen={modalState.channelModalOpen}
                moduleKey={modalState.channelModalModuleKey}
                onClose={() => modalState.setChannelModalOpen(false)}
            />

            <AddDatabaseModal
                isOpen={modalState.addDatabaseModalOpen}
                workspaceKey={modalState.activeWorkspaceKey}
                onClose={() => modalState.setAddDatabaseModalOpen(false)}
            />
        </>
    );
};

export default SidebarBucketsModals;